// src/body.tsx
import { jsx } from "react/jsx-runtime";
var Body = ({
  children,
  style,
  ...props
}) => {
  const styleDefault = {
    wordSpacing: "normal",
    ...style
  };
  return /* @__PURE__ */ jsx("body", { ...props, "data-id": "__react-email-body", style, children });
};
Body.displayName = "Body";
export {
  Body
};
